import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ProjectMetricsStyles as styles } from './project-metrics.styles';
import { ProjectMetricsTemplate as template } from './project-metrics.template';
import { IProjectService, IVppaService } from '../../../../../services';
import {
  AVERAGE_TYPE,
  IMetric,
  IProjectMetrics,
  IVppa,
  IVppaMetrics
} from '../../../../../types';
import { logger } from '@genesislcap/foundation-comms';
import { PRODUCT_TYPE } from '../../../../../utils';

const name = 'project-metrics';

@customElement({
  name,
  template,
  styles
})
export class ProjectMetrics extends FASTElement {
  @IProjectService projectService: IProjectService;
  @IVppaService vppaService: IVppaService;
  @attr @observable vppa: any;
  @attr @observable projectId: string = '';
  @attr @observable selectedProductType: PRODUCT_TYPE;
  @observable projectMetrics: IProjectMetrics;
  @observable financialMetrics: IMetric[] = [];
  @observable carbonMetrics: IMetric[] = [];
  @observable averageTypeValue: AVERAGE_TYPE = AVERAGE_TYPE.SINGLE_ISO;

  private financialMetricsFields = ['EXPECTED_SETTLEMENT_CONTRACT_DATES_USD_PER_MWH', 'BASIS_ASGEN_3_YEAR_USD_PER_MWH'];
  private carbonMetricsFields = ['LME_ASGEN_NODE_3_YEAR_MT_CO2E_PER_MWH', 'LME_ASGEN_HUB_CONTRACT_DATES_MT_CO2E_PER_MWH', 'CARBON_PRICE_CONTRACT_DATES_USD_PER_MT_CO2E', 'CFE_3_YEAR_PERCENT'];


  connectedCallback(): void {
    super.connectedCallback();
    this.getProjectMetrics();
  }

  public getProjectMetrics() {
    if (this.projectId) {
      this.projectService
        .getProjectMetrics(this.projectId)
        .then((response) => {
          if (response && response.REPLY.length > 0) {
            this.projectMetrics = response.REPLY[0];
            this.setMetricsTiles(this.projectMetrics);
          }
        })
        .catch((error) => {
          logger.error(error);
        });
    }
  }

  private setMetricsTiles(projectMetrics: IProjectMetrics) {
    const financialMetrics = [];
    const carbonMetrics = [];

    if (projectMetrics?.PROJECT_METRICS) {
      let vppaMetrics: IVppaMetrics = {} as IVppaMetrics;

      if (this.vppa?.VPPA_ID) {
        vppaMetrics = projectMetrics.PROJECT_METRICS.filter((vppaMetric) => vppaMetric.VPPA_ID === this.vppa.VPPA_ID)[0];
      } else {
        vppaMetrics = projectMetrics.PROJECT_METRICS.filter((vppaMetric) => vppaMetric.VPPA_ID === '')[0];
      }

      this.financialMetricsFields.forEach(fieldName => {
        let metric: IMetric = this.getMetric(vppaMetrics, fieldName);

        if(metric) {
          financialMetrics.push(metric);
        }
      });

      this.carbonMetricsFields.forEach(fieldName => {
        let metric: IMetric = this.getMetric(vppaMetrics, fieldName);

        if(metric) {
          carbonMetrics.push(metric);
        }
      });
    }

    this.financialMetrics = financialMetrics;
    this.carbonMetrics = carbonMetrics;
  }

  private getMetric(vppaMetrics: IVppaMetrics, fieldName: String) {
    let metric: IMetric;
    if (this.averageTypeValue === AVERAGE_TYPE.SINGLE_ISO) {
      metric = vppaMetrics.SINGLE_ISO_METRICS.filter((metric) => metric.FIELD_NAME === fieldName)[0];
    } else if (this.averageTypeValue === AVERAGE_TYPE.ALL_ISOS) {
      metric = vppaMetrics.ALL_ISO_METRICS.filter((metric) => metric.FIELD_NAME === fieldName)[0];
    }
    return metric
  }

  vppaChanged(oldValue, newValue: IVppa) {
    this.setMetricsTiles(this.projectMetrics);
  }

  averageTypeValueChanged() {
    if(this.projectMetrics)
      this.setMetricsTiles(this.projectMetrics);
  }

  projectIdChanged() {
    this.getProjectMetrics();
  }
}
